import {Typography} from '@material-ui/core';
import React from 'react';
import './LabelValue.scss';

// create a react functional component to render the Label value with Label label
const LabelValue = ({
  label,
  value,
  onClickAction,
  className = ''
}: {
  label: string;
  value: string | React.ReactNode;
  onClickAction?: string | React.ReactNode;
  className?: string;
}): React.ReactElement => {
  const handleClickAction = (): void => {
    if (typeof onClickAction === 'function') {
      onClickAction();
    }
  };
  return (
    <div className={`label-value-wrapper ${className}`}>
      <Typography className="label-label">{label}</Typography>
      <Typography
        className="label-value-text"
        onClick={() => handleClickAction()}>
        {value}
      </Typography>
    </div>
  );
};

export default LabelValue;
